"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CreateApiKeyComponent = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APCheckbox = _interopRequireDefault(require("../../common/APCheckbox"));
var _APButton = _interopRequireDefault(require("../../common/APButton"));
var _classnames = _interopRequireDefault(require("classnames"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _lodash = require("lodash");
require("./CreateApiKeyComponent.css");
var _APInput = _interopRequireDefault(require("../../common/APInput"));
var _APRadio = _interopRequireDefault(require("../../common/APRadio/APRadio"));
var _APChip = _interopRequireDefault(require("../../common/APChip/APChip"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('create-api-key');
var IpWhiteListErrors = new Map([['Empty', 'Please enter a value.'], ['Max', 'You can only add 3 IP Addresses to Whitelist.'], ['Invalid', 'Your IP address is invalid.']]);
var CreateApiKeyComponent = exports.CreateApiKeyComponent = /*#__PURE__*/function (_React$Component) {
  function CreateApiKeyComponent(props) {
    var _this;
    _classCallCheck(this, CreateApiKeyComponent);
    _this = _callSuper(this, CreateApiKeyComponent, [props]);
    _defineProperty(_this, "onRemoveIpAddress", function (IPAddress) {
      var newIpAddresses = new Set(_toConsumableArray(_this.state.IpWhiteList));
      newIpAddresses["delete"](IPAddress);
      _this.setState({
        IpWhiteList: newIpAddresses
      });
    });
    _defineProperty(_this, "onAddIPAddress", function (event) {
      event.preventDefault();
      var ipRegex = /((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))/;
      _this.setState({
        error: ''
      });

      // Find the value from clicking add button since its not in redux form
      var value = event.currentTarget.parentElement.parentElement.children[1].value;
      if ((0, _lodash.isEmpty)(value)) {
        _this.setState({
          error: 'Empty'
        });
      } else if (_this.state.IpWhiteList.size >= 3) {
        _this.setState({
          error: 'Max'
        });
      } else if (!ipRegex.test(value)) {
        _this.setState({
          error: 'Invalid'
        });
      } else {
        var newIpAddresses = _this.state.IpWhiteList.add(value);
        _this.setState({
          IpWhiteList: newIpAddresses
        });

        // Set values in Redux Form so they will show in payload
        _this.props.changeFieldValue('IpWhiteList', _toConsumableArray(newIpAddresses).join(','));

        // Reset ReduxForm Field so entered value is cleared.
        _this.props.changeFieldValue('IpWhiteListInput', '');
      }
    });
    _this.state = {
      error: '',
      ipRestricted: false,
      IpWhiteList: new Set()
    };
    return _this;
  }
  _inherits(CreateApiKeyComponent, _React$Component);
  return _createClass(CreateApiKeyComponent, [{
    key: "toggleIPRestrictions",
    value: function toggleIPRestrictions() {
      this.setState({
        ipRestricted: !this.state.ipRestricted
      });
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$props = this.props,
        error = _this$props.error,
        pristine = _this$props.pristine,
        submitting = _this$props.submitting,
        handleSubmit = _this$props.handleSubmit;
      return /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: handleSubmit,
        className: (0, _classnames["default"])('form-inline', baseClasses('slide-pane-body'))
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('header')
      }, t('Create New API Key')), /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('form-body')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('frame')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('title')
      }, t('Choose the following activities to allow the API Key to access:')), /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('input-wrapper')
      }, /*#__PURE__*/_react["default"].createElement(_APCheckbox["default"], {
        name: "trading",
        label: t('Trading'),
        id: "trading",
        customClass: baseClasses()
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('input-wrapper')
      }, /*#__PURE__*/_react["default"].createElement(_APCheckbox["default"], {
        name: "deposit",
        label: t('Deposits'),
        id: "deposit",
        customClass: baseClasses()
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('input-wrapper')
      }, /*#__PURE__*/_react["default"].createElement(_APCheckbox["default"], {
        name: "withdraw",
        label: t('Withdrawals'),
        id: "withdraw",
        customClass: baseClasses()
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('input-wrapper')
      }, /*#__PURE__*/_react["default"].createElement(_APCheckbox["default"], {
        name: "accountReadOnly",
        label: t('Read-only'),
        id: "viewonly",
        customClass: baseClasses()
      })), error && pristine ? /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('error')
      }, error) : null), /*#__PURE__*/_react["default"].createElement("section", {
        className: "create-api-key-ip-whitelist"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "create-api-key-ip-whitelist__header"
      }, t('IP access restrictions:')), /*#__PURE__*/_react["default"].createElement(_APRadio["default"], {
        name: "restricted",
        value: false,
        checked: !this.state.ipRestricted,
        onChange: this.toggleIPRestrictions.bind(this),
        label: t('Unrestricted ( Less Secure ).'),
        id: "create-api-key-not-restricted"
      }), /*#__PURE__*/_react["default"].createElement(_APRadio["default"], {
        name: "restricted",
        value: true,
        checked: this.state.ipRestricted,
        onChange: this.toggleIPRestrictions.bind(this),
        label: t('Restrict access to trusted IPs only ( Recommended )'),
        id: "create-api-key-restricted"
      }), this.state.ipRestricted && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, !(0, _lodash.isEmpty)(this.state.error) && /*#__PURE__*/_react["default"].createElement("div", {
        className: "create-api-key-ip-whitelist__error"
      }, IpWhiteListErrors.get(this.state.error)), this.state.IpWhiteList.size > 0 && /*#__PURE__*/_react["default"].createElement(_APChip["default"], {
        values: _toConsumableArray(this.state.IpWhiteList),
        onCloseClick: this.onRemoveIpAddress.bind(this)
      }), /*#__PURE__*/_react["default"].createElement(_APInput["default"], {
        buttonInInput: true,
        placeholder: "-",
        name: "IpWhiteListInput",
        onButtonClick: this.onAddIPAddress.bind(this)
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('footer')
      }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
        type: "submit",
        customClass: baseClasses(),
        disabled: submitting,
        styleName: "additive"
      }, submitting ? t('Processing...') : t('Create')))));
    }
  }]);
}(_react["default"].Component);
CreateApiKeyComponent.propTypes = {
  handleSubmit: _propTypes["default"].func.isRequired,
  submitting: _propTypes["default"].bool.isRequired
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)('core')(CreateApiKeyComponent);